<template>
  <div>
    <div class="max-w-5xl mx-auto space-y-16">
      <AdsetListComponent
        :fetching="fetching"
        :adsets="adsets"
        :meta="meta"
        @get-adsets="handleGetAdsets"
      />
    </div>
  </div>
</template>

<script>
import { facebookCampaignAdsetComputed, facebookCampaignAdsetMethods } from '@/store/adminHelper';
import AdsetListComponent from '@/components/FacebookAdsets/List.vue';

export default {
  name: 'AdsetList',
  components: {
    AdsetListComponent,
  },
  props: {
    facebookCampaignId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...facebookCampaignAdsetComputed,
  },
  created() {
    this.handleGetAdsets();
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...facebookCampaignAdsetMethods,
    async handleGetAdsets(queryParams = {}) {
      const { facebookCampaignId } = this;
      this.fetching = true;
      try {
        await this.getFacebookCampaignAdsets({
          facebookCampaignId,
          queryParams: {
            ...queryParams,
            include: 'adLifetimeReports',
          },
        });
      } catch (error) {
        //
      } finally {
        this.fetching = false;
      }
    },
  },
};
</script>
